<template>
  <div class="layout-segment-stack" :class="getLayoutSegmentClass">
    <div class="layout-segment-label">{{ getSegmentLabel }}</div>
    <div class="layout-segment">
      <SegmentColor :segment="getSegment" :type="type" />
      <div class="layout-segment-values">
        <SegmentExpansion ref="expansion" :type="type" :segment="segment" :num="num" />
        <NumericField :segment="getSegment" :type="'pipe'" layout="row" />
      </div>
      <SegmentRemove v-show="num > -1 && getIsPrint" @click="handleRemove" class="remove-btn" />
      <div :id="'se-segment' + getSegment.id" v-if="type === 'pipe'" @mouseover="handleHoverPipe"
        @mouseout="handleHoverExit" class="edit-btn" v-show="getIsPrint">
        <img style="width: 16px;" :src="require('@/assets/svg/SVG/info-icon.svg')" />
      </div>
      <div v-if="IsInfo" class="layout-segment-info-box">
        <div class="layout-segment-info">
          <table>
            <tbody>
              <tr>
                <th class="layout-segment-info-th">Description</th>
                <td>{{ pipeSeg.desc }}</td>
              </tr>
              <tr>
                <th class="layout-segment-info-th">Class</th>
                <td>{{ pipeSeg.class }}</td>
              </tr>
              <tr>
                <th class="layout-segment-info-th">Roughness</th>
                <td>{{ pipeSeg.roughness }}</td>
              </tr>
              <tr>
                <th class="layout-segment-info-th">Max Pressure</th>
                <td>{{ (filterPressure(pipeSeg.max_pressure_Pa)).toFixed(1) }} {{ PressureUnit }}</td>
              </tr>
              <tr>
                <th class="layout-segment-info-th">Code</th>
                <td>{{ pipeSeg.code }}</td>
              </tr>
              <tr>
                <th class="layout-segment-info-th">Usage</th>
                <td>{{ pipeSeg.usage }}</td>
              </tr>
              <tr>
                <th class="layout-segment-info-th">ø NPS</th>
                <td>{{ (filterDiameter(pipeSeg.nominal_dia_m)).toFixed(1) }} {{ DiameterUnit }}</td>
              </tr>
              <tr>
                <th class="layout-segment-info-th">ø ID</th>
                <td>{{ (filterDiameter(pipeSeg.internal_dia_m)).toFixed(1) }} {{ DiameterUnit }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NumericField from '@/components/nelson/NumericField';
import SegmentColor from '@/components/layout/SegmentColor';
import SegmentExpansion from '@/components/layout/SegmentExpansion';
import SegmentExpandButton from '@/components/layout/SegmentExpandButton';
import SegmentRemove from '@/components/layout/SegmentRemove';
import { useInputStore } from '@/store/InputStore';
import { useModalStore } from '@/store/ModalStore';
import { useSegmentStore } from '@/store/SegmentStore';
import { usePrintStore } from '@/store/PrintStore';
import {usePipeStore} from '@/store/PipeStore';
import { useSettingsStore } from '@/store/SettingsStore';

export default {
  name: 'LayoutSegment',
  components: {
    SegmentExpansion,
    SegmentColor,
    SegmentExpandButton,
    NumericField,
    SegmentRemove
  },
  data () {
    return {
      isInfo: false,
    };
  },
  props: [
    'type',
    'num',
    'remove',
    'segment',
    'expand'
  ],
  computed: {
    PressureUnit () {
      return useSettingsStore().getPressureUnit;
    },
    DiameterUnit () {
      return useSettingsStore().getDiameterUnit;
    },
    IsInfo () {
      return this.isInfo;
    },
    getSegmentLabel () {
      return this.$props.type.toUpperCase() + ' ' + (this.$props.num + 1);
    },
    getSegment () {
      return this.$props.segment;
    },
    pipeSeg () {
      const pipeStore = usePipeStore();
      return pipeStore.getPipeById(this.segment.id);
    },
    getIsPrint () {
      return !usePrintStore().getPrintIsOpen;
    },
    getLayoutSegmentClass () {

      if (this.type === 'slope') {
        if (this.num === 0) {
          return 'layout-slope-start';
        } else {
          return 'layout-slope';
        }
      }
    },
    getTrimW () {
      return (useSegmentStore().getAllSegmentLengths('slope') - this.getAllPipesLength);
    },
    getAllPipesLength () {
      return useSegmentStore().getAllSegmentLengths('pipe');
    },
    getMagScale () {
      return useSegmentStore().getMagScale;
    },
  },
  methods: {
    filterDiameter (diameter) {
      return useSettingsStore().filterDiameter(diameter);
    },
    filterPressure (pressure) {
      return useSettingsStore().filterPressure(pressure);
    },
    handleExpand () {
      this.$refs.expandButton.toggle();
      this.$refs.expansion.toggle();
    },
    expandSegment () {
      this.$refs.expandButton.expand();
      this.$refs.expansion.expand();
    },
    closeSegment () {
      this.$refs.expandButton.close();
      this.$refs.expansion.close();
    },
    handleRemove () {
      const modalStore = useModalStore();
      modalStore.setModalObj({
        promptLabel: 'Remove ' + this.$props.type.charAt(0).toUpperCase() + this.$props.type.slice(1) + ' Segment',
        promptDescription: 'Are you sure you want to remove this segment?',
        buttonALabel: 'Delete',
        buttonAFunc: (this.$props.segment.isInlet) ? this.ensureInletDelete : this.handleDelete,
        buttonBLabel: 'Cancel',
        buttonBFunc: this.handleModalCancel
      });
      modalStore.showModal('prompt');
    },
    ensureInletDelete () {
      useModalStore().setModalObj({
        promptLabel: 'Pipe Inlet Reset',
        promptDescription: 'The pipe to be deleted contains the inlet. The inlet will reset back 0. Are you sure you\'d like to delete this pipe segment?',
        buttonALabel: 'Yes, Delete',
        buttonAFunc: this.handleDeleteAndInletReset,
        buttonBLabel: 'Cancel',
        buttonBFunc: this.handleModalCancel
      });
    },
    handleDelete () {
      this.$props.remove(this.$props.num);
      useModalStore().hideModal();
      useInputStore().sprinklerCalc();
    },
    handleDeleteAndInletReset () {
      useSegmentStore().setInletPosition(0);
      this.handleDelete();
    },
    handleModalCancel () {
      useModalStore().hideModal();
    },
    handleHoverPipe () {
      this.isInfo = true;
    },
    handleHoverExit () {
      this.isInfo = false;
    }
    // handleEditPipe () {
    //   const pipeStore = usePipeStore();
    //   let pipe = pipeStore.getPipeById(this.segment.id);
    //   pipeStore.getPipes.forEach((element) => {
    //     element.isHover = false;
    //   });
    //   pipeStore.setPipeModalVisible(true);
    //   pipeStore.setEditedPipe(pipe);
    //   useModalStore().showModal('pipe');
    // }
  }
};
</script>

<style scoped>
.layout-segment {
  display: flex;
  border-top: .5px solid gray;
  position: relative;
}
.layout-segment-stack {
  display: flex;
  flex-direction: column;
  background-color: whitesmoke;
  max-width: 25%;
  min-width: 25%;
  -webkit-box-shadow: 6px 6px 17px -2px rgba(0,0,0,0.18);
  -moz-box-shadow: 6px 6px 17px -2px rgba(0,0,0,0.18);
  box-shadow: 6px 6px 17px -2px rgba(0,0,0,0.18);
}

.layout-slope-start {
  min-width: 30%;
  max-width: 30%;
}

.layout-slope {
  min-width: calc((100% - 30%)/3);
  max-width: calc((100% - 30%)/3);
}

.selected {
  background-color: #eaeaea;
}
.layout-segment-label {
  font-size: .65em;
  font-weight: bold;
  border-top: .5px solid gray;
  border-left: .5px solid gray;
  padding-left: 5px;
}
.remove-btn {
/*  margin-top:-10px;
  margin-right: 10px;*/
  position: absolute;
  right: 5px;
  top: -25px;
}

.layout-segment-values {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.edit-btn {
  position: absolute;
  right: 30px;
  top: -25px;
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  border-radius: 15px;

  cursor:pointer;
}
.layout-segment-info-box {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-align: center;
  font-family: Arial, sans-serif;
  font-size: 13px;
  transition: all 0.3s ease;
  /* Smooth transition */
}
.layout-segment-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 180px;
    background-color: #ffffff;
  height: 180px;
    border: 2px solid #D3D3D3;
}
.layout-segment-info-th {
  text-align: start;
}


</style>